import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Button from '../../layouts/theme-onboarding/Button'; 
import AddIcon from '@mui/icons-material/Add';
import ButtonGroup from '@mui/material/ButtonGroup';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import ListAddress from './address/ListAddress';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Typography from '../../layouts/theme-onboarding/Typography';
import data from '../../config/address.json';
import { initStep4Data } from '../../utils/object/Signup';
import countryData from '../../config/country.json';
import provinceData from '../../config/province.json';
import districtData from '../../config/district.json';
import { showAlert } from '../../redux/create-actions/AlertAction';
import { useDispatch } from 'react-redux';
import Stack from '@mui/material/Stack';
import HomeIcon from '@mui/icons-material/Home';
import Color from '../../layouts/Color';

const info = { textAlign: 'left' };
const btnGroup = { float: 'right' };
const container = { mt: 1 };
const iconColor = { color: Color.Main};
const buttonAdd = {
  color: Color.Button,
  backgroundColor: Color.Sub,
  '&:hover': { background: Color.Button, color: Color.Normal }
};
const buttonSave = {
  color: Color.Button,
  backgroundColor: Color.Main,
  '&:hover': { background: Color.Button, color: Color.Normal }
};
const formWidth = { minWidth: 120 };

export default function Address(props) {
  const [addressType, setAddressType] = useState('');
  const [listAddresses, setListAddresses] = useState(initStep4Data(props.baseAddress, null, null));
  const [country, setCountry] = useState('');
  const [province, setProvince] = useState('');
  const [district, setDistrict] = useState('');
  const [detailAddress, setDetailAddress] = useState('');
  const [renderForm, setRenderForm] = useState(false);
  const dispatch = useDispatch();

  const handleChangeCountry = (event) => {
    setCountry(event.target.value);
  };

  const handleChangeProvince = (event) => {
    setProvince(event.target.value);
  };

  const handleChangeDistrict = (event) => {
    setDistrict(event.target.value);
  };

  const handleChangeDetailAddress = (event) => {
    setDetailAddress(event.target.value);
  };

  const renderOptionCountry = countryData.countries.map((item, i) => {
    return (
      <MenuItem value={item.name} key={i}>{item.name}</MenuItem>
    );
  });

  const renderOptionProvince = provinceData.provinces.map((item, i) => {
    return (
      <MenuItem value={item.province} key={i}>{item.province}</MenuItem>
    );
  });

  const renderOptionDistrict = districtData.districts.map((item, i) => {
    return (
      <MenuItem value={item.district} key={i}>{item.district}</MenuItem>
    );
  });

  const handleChangeAddressType = (event) => {
    setAddressType(event.target.value);
    setCountry('');
    setProvince('');
    setDistrict('');
  };

  const handleAddAddress = () => {
    setCountry('');
    setProvince('');
    setDistrict('');
    setRenderForm(true);
  };

  const handleSaveAddress = () => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    let address = {
      addressType: addressType,
      district: district,
      province: province,
      country: country,
      detailAddress: detailAddress
    }
    if (addressType === '' || district === '' || province === '' || country === '' || detailAddress === '') {
      alert = { ...alert, message: 'Please provide correct address!' }
      dispatch(showAlert(alert));
    } else {
      let newAddress = address.detailAddress + ' huyện ' + district + ' tỉnh ' + province + ' ' + country;
      switch (address.addressType) {
        case "PERMANENT":
          setListAddresses({ ...listAddresses, permanentAddress: newAddress });
          break;
        case "CARD":
          setListAddresses({ ...listAddresses, cardAddress: newAddress });
          break;
        default:
          break;
      }
      setRenderForm(false);
      props.onUpdateStep4Data(listAddresses);
    }
  };

  const renderOptionAddressType = data.addresses.map((item, i) => {
    return (
      <MenuItem value={item.code} key={i}>{item.name}</MenuItem>
    );
  });

  const deletePermanentAddress = () => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    setListAddresses({ ...listAddresses, permanentAddress: null });
    alert = { ...alert, severity: 'success', message: 'Removed permanent address!' }
    dispatch(showAlert(alert));
  }

  const deleteCardAddress = () => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    setListAddresses({ ...listAddresses, cardAddress: null });
    alert = { ...alert, severity: 'success', message: 'Removed card address!' }
    dispatch(showAlert(alert));
  }

  const renderFormAddress = (render) => {
    return render ? (
      <React.Fragment>
        <Grid item xs={12} sm={4}>
          <FormControl sx={formWidth} fullWidth>
            <InputLabel id="demo-simple-select-helper-label">Address Type: </InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={addressType}
              label="Address Type"
              onChange={handleChangeAddressType}
            >
              {renderOptionAddressType}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={8}>

        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-helper-label">Country: </InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={country}
              label="Country"
              onChange={handleChangeCountry}
            >
              {renderOptionCountry}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-helper-label">Province: </InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={province}
              label="Province"
              onChange={handleChangeProvince}
            >
              {renderOptionProvince}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-helper-label">District: </InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={district}
              label="District"
              onChange={handleChangeDistrict}
            >
              {renderOptionDistrict}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            required
            id="detail"
            name="detail"
            label="Detail Address"
            fullWidth
            autoComplete="address detail"
            variant="standard"
            onChange={handleChangeDetailAddress}
          />
        </Grid> </React.Fragment>) : (<div></div>);
  }

  return (
    <React.Fragment>
      <Stack direction="row" justifyContent="center" spacing={1}>
        <Typography variant="h6" marked="left" gutterBottom color={Color.Main}>Address</Typography>
        <HomeIcon sx={iconColor}></HomeIcon>
      </Stack>
      <Grid container spacing={3} sx={{container}}>
      <Grid item xs={12} sx={info}> 
        <Typography variant="subtitle1" color={Color.Main}>  Please provide permanent address and card address if it is essential: </Typography>
      </Grid>
        <Grid item xs={12} sm={8}></Grid>
        <Grid item xs={12} sm={4}>
          <ButtonGroup aria-label="outlined primary button group" sx={btnGroup}>
            <Button variant="outlined" sx={buttonAdd} onClick={handleAddAddress}>
              Add <AddIcon fontSize='small'></AddIcon>
            </Button>
            <Button variant="outlined" sx={buttonSave} onClick={handleSaveAddress}>
              Save <SaveAsIcon fontSize='small'></SaveAsIcon>
            </Button>
          </ButtonGroup>
        </Grid>
        {renderFormAddress(renderForm)}
        <Grid item xs={12} sm={12}>
          <ListAddress listAddresses={listAddresses} deletePermanentAddress={deletePermanentAddress}
            deleteCardAddress={deleteCardAddress}></ListAddress>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}